// React
import { useState } from "react";
import isEmpty from "../../validation/is-empty";

// Components
import Table from "../table/Table";
import Spinner from "../common/Spinner";

// API
import { useSystemDashboardCostPlans } from "../../api/projects/ProjectAPI";

// Functions
import { countReports } from "./SystemDashboard.functions";
import ExportSystemDashboard from "./ExportSystemDashboard";
import { columns } from "./SystemDashboardCostPlanTable.functions";
import { tranStr } from "../../utils/translation";

// Style
import "./SystemDashboardTable.css";

export default function SystemDashboardCostPlanTable() {
  const { systemDashboardCostPlans } = useSystemDashboardCostPlans();

  // Table Row Selection
  const [selectedChecked, setSelectedChecked] = useState([]);
  const [selectedRow, setSelectedRow] = useState({});
  const [modal, setModal] = useState(false);

  if (
    isEmpty(systemDashboardCostPlans.data) &&
    systemDashboardCostPlans.loading
  ) {
    return (
      <div className="toggle-button-text-container">
        <Spinner />
      </div>
    );
  }

  const { totalCostPlans } = countReports(systemDashboardCostPlans.data);

  return (
    <div className="toggle-button-text-container">
      <p>
        <b>Project Cost Plan</b>
      </p>
      <p>
        <b>Total Cost Plans: {totalCostPlans}</b>
      </p>
      <Table
        title={tranStr("Cost Plan Table")}
        tableArray={systemDashboardCostPlans.data}
        columns={columns()}
        tableSize={15}
        isTitleDisabled={true}
        isTotalDisabled={true}
        // Checked Selection
        checked={selectedChecked}
        setChecked={setSelectedChecked}
        // Row Selection
        selectedRow={selectedRow}
        setSelectedRow={setSelectedRow}
        // Modal Control
        modal={modal}
        setModal={setModal}
      />
      <ExportSystemDashboard
        projects={systemDashboardCostPlans.data}
        inputMode={"COSTPLAN"}
      />
    </div>
  );
}
